// extracted by mini-css-extract-plugin
export var checkboxGroup = "checkbox-group-module--checkbox-group--slJbT";
export var checkboxGroup__label = "checkbox-group-module--checkbox-group__label--pmJPs";
export var checkboxGroup__checkbox = "checkbox-group-module--checkbox-group__checkbox--ZvZKl";